import { useContext } from 'react';
import { TimezoneContext } from '../providers/timezone.provider';

export const useTimezone = () => {
  const context = useContext(TimezoneContext);
  if (!context) throw new Error('useTimezone debe ser utilizado dentro de un TimezoneProvider');
  return context;
};
